var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7308_48324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1667 2.66675C10.1667 2.39061 10.3906 2.16675 10.6667 2.16675H13.3334C13.6096 2.16675 13.8334 2.39061 13.8334 2.66675V5.33341C13.8334 5.60956 13.6096 5.83341 13.3334 5.83341C13.0573 5.83341 12.8334 5.60956 12.8334 5.33341V3.16675H10.6667C10.3906 3.16675 10.1667 2.94289 10.1667 2.66675Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6868 2.31319C13.8821 2.50846 13.8821 2.82504 13.6868 3.0203L9.68681 7.0203C9.49154 7.21556 9.17496 7.21556 8.9797 7.0203C8.78444 6.82504 8.78444 6.50846 8.9797 6.31319L12.9797 2.31319C13.175 2.11793 13.4915 2.11793 13.6868 2.31319Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66675 10.1667C2.94289 10.1667 3.16675 10.3906 3.16675 10.6667V12.8334H5.33341C5.60956 12.8334 5.83341 13.0573 5.83341 13.3334C5.83341 13.6096 5.60956 13.8334 5.33341 13.8334H2.66675C2.39061 13.8334 2.16675 13.6096 2.16675 13.3334V10.6667C2.16675 10.3906 2.39061 10.1667 2.66675 10.1667Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0203 8.9797C7.21556 9.17496 7.21556 9.49154 7.0203 9.68681L3.0203 13.6868C2.82504 13.8821 2.50846 13.8821 2.31319 13.6868C2.11793 13.4915 2.11793 13.175 2.31319 12.9797L6.31319 8.9797C6.50846 8.78444 6.82504 8.78444 7.0203 8.9797Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 10.1667C13.6096 10.1667 13.8334 10.3906 13.8334 10.6667V13.3334C13.8334 13.6096 13.6096 13.8334 13.3334 13.8334H10.6667C10.3906 13.8334 10.1667 13.6096 10.1667 13.3334C10.1667 13.0573 10.3906 12.8334 10.6667 12.8334H12.8334V10.6667C12.8334 10.3906 13.0573 10.1667 13.3334 10.1667Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9797 8.9797C9.17496 8.78444 9.49154 8.78444 9.68681 8.9797L13.6868 12.9797C13.8821 13.175 13.8821 13.4915 13.6868 13.6868C13.4915 13.8821 13.175 13.8821 12.9797 13.6868L8.9797 9.68681C8.78444 9.49154 8.78444 9.17496 8.9797 8.9797Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16675 2.66675C2.16675 2.39061 2.39061 2.16675 2.66675 2.16675H5.33341C5.60956 2.16675 5.83341 2.39061 5.83341 2.66675C5.83341 2.94289 5.60956 3.16675 5.33341 3.16675H3.16675V5.33341C3.16675 5.60956 2.94289 5.83341 2.66675 5.83341C2.39061 5.83341 2.16675 5.60956 2.16675 5.33341V2.66675Z",
    fill: "#141621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31319 2.31319C2.50846 2.11793 2.82504 2.11793 3.0203 2.31319L7.0203 6.31319C7.21556 6.50846 7.21556 6.82504 7.0203 7.0203C6.82504 7.21556 6.50846 7.21556 6.31319 7.0203L2.31319 3.0203C2.11793 2.82504 2.11793 2.50846 2.31319 2.31319Z",
    fill: "#141621"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7308_48324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximise);
export default __webpack_public_path__ + "static/media/maximise.18360b8f9329aa09fccafc63af7d143a.svg";
export { ForwardRef as ReactComponent };